import {createContext} from 'react';

export const ColorModeContext = createContext({
  toggleColorMode: () => {
    // This is intentional
  },
});